import { useGenericSocket } from "@/hooks/useGenericSocket";
import { SocketTopics } from "@/lib/natsConnection";
import { useCallback } from "react";

// "ZROUSDT":{"topBuyPrc":0.3,"topSellPrc":0.21,"buyVolume":35210.36,"sellVolume":24986.67,"deltaPrc":16.98}
export interface ITopGainersBuySell {
  topBuyPrc: number;
  topSellPrc: number;
  buyVolume: number;
  sellVolume: number;
  deltaPrc: number;
}

export interface ITopGainersBuySellResponse {
  [timeframe: string]: {
    [symbol: string]: ITopGainersBuySell;
  };
}

export interface ITopGainersBuySellRow {
  symbol: string;
  topBuyPrc: number;
  topSellPrc: number;
  buyVolume: number;
  sellVolume: number;
  deltaPrc: number;
}

export function useTopGainersBuySell(timeframe: string) {
  const handler = useCallback(
    (_: ITopGainersBuySellRow[], newData: ITopGainersBuySellResponse) => {
      // convert ITopGainersPriceResponse to ITopGainersPriceRow
      const rows = Object.entries(newData[timeframe] || {}).map(
        ([symbol, value]) => ({
          symbol,
          topBuyPrc: value.topBuyPrc,
          topSellPrc: value.topSellPrc,
          buyVolume: value.buyVolume,
          sellVolume: value.sellVolume,
          deltaPrc: value.deltaPrc,
        }),
      );

      return rows as ITopGainersBuySellRow[];
    },
    [timeframe],
  );

  return useGenericSocket<ITopGainersBuySellRow[], ITopGainersBuySellResponse>(
    SocketTopics.topGainersBuySell,
    handler,
  );
}
